import React from "react";
import { STATE_RING } from "../../lib/state-ring.js";
import { cn } from "../../lib/utils.js";
import type { PeopleFieldResolvedLabels } from "./people-field-labels.js";

/* states-check-ignore: the row is never focused; the active option is
   painted through aria-activedescendant (PeopleFieldRow's rule). */

/** The workspace section's last option: Enter or a press fetches the next page. */
export function PeopleFieldLoadMoreRow({
  id,
  active,
  labels,
  loadingMore,
  loadMoreFailed,
  onHover,
  onPick,
}: {
  readonly id: string;
  readonly active: boolean;
  readonly labels: PeopleFieldResolvedLabels;
  readonly loadingMore: boolean;
  readonly loadMoreFailed: boolean;
  readonly onHover: () => void;
  readonly onPick: () => void;
}): React.ReactElement {
  return (
    <div
      id={id}
      role="option"
      tabIndex={-1}
      aria-selected={false}
      onMouseEnter={onHover}
      onMouseDown={(event) => {
        event.preventDefault();
        onPick();
      }}
      className={cn(
        "cursor-pointer rounded-md px-2 py-2 text-center text-caption font-medium text-pb-text-secondary",
        active && `pb-overlay-paint ${STATE_RING.neutral}`,
      )}
    >
      {loadingMore
        ? labels.loadingMore
        : loadMoreFailed
          ? labels.loadMoreFailed
          : labels.loadMore}
    </div>
  );
}
